export default __webpack_public_path__ + "images/8115f1fa9286715433a96a358564cb96.png";